import { render, staticRenderFns } from "./FailOrder.vue?vue&type=template&id=867583e8&scoped=true"
import script from "./FailOrder.vue?vue&type=script&lang=js"
export * from "./FailOrder.vue?vue&type=script&lang=js"
import style0 from "./FailOrder.vue?vue&type=style&index=0&id=867583e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867583e8",
  null
  
)

export default component.exports